import * as React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Button } from 'relevant-ui'
import { withTranslation } from 'react-i18next'
import {
  Field,
  reduxForm,
  getFormValues,
} from 'redux-form'
import { FIELDS } from '../types'
import InputField from '@App/components/fields/InputField'
import { SUBMIT } from '@App/constantes'

class Code extends React.Component<any, any> {
  constructor(props: any) {
    super(props)

    this.state = {}

    this.onSubmit = this.onSubmit.bind(this)
  }

  onSubmit() {
    this.props.onSubmit(this.props[FIELDS.CODE])
  }

  render() {
    const {
      invalid,
      pristine,
      t,
      handleSubmit,
    } = this.props

    return (
      <div className="customform customform--padding">
        <p className="customform__title customform__title--center">Etape 2</p>

        <p className="customform__desc" style={{ textAlign: 'center' }}>
          Add an extra layer of security with Two-Step verification
          Lorem ipsum dolor sit, amet consectetur adipisicing elit. Vel saepe quod modi labore
        </p>

        <form
          onSubmit={handleSubmit(this.onSubmit)}
          className="customForm mt-20"
          style={{ marginLeft: 'auto', marginRight: 'auto', maxWidth: '500px' }}
        >
          <div className="customform__row">
            <div className="formGroup formGroup--large">
              <Field
                name={FIELDS.CODE}
                component={InputField}
                label={t('code')}
                secondary
              />
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              button="primary"
              size="large"
              type="submit"
              disabled={pristine || invalid}
              label={SUBMIT}
            />
          </div>
        </form>
      </div>
    )
  }
}

const validate = (values: any) => {
  const error = {}
  const regex = /^[0-9]{6}$/

  if (!values[FIELDS.CODE]) {
    error[FIELDS.CODE] = 'Field cannot be empty'
  }

  if (values[FIELDS.CODE] && !regex.test(values[FIELDS.CODE])) {
    error[FIELDS.CODE] = 'The code is not in the expected format'
  }

  return error
}

const NewCodeForm = reduxForm({
  validate,
  form: FIELDS.FORM,
})(Code as any)

const mapStateToProps = (state: any): any => {
  const values = getFormValues(FIELDS.FORM)(state) || {}
  return {
    ...values,
  }
}

export default compose(
  withTranslation(),
  connect(mapStateToProps),
)(NewCodeForm)
